import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IEpDropdownModel } from '@epicor/kinetic';
import { FieldAgentClient, Currency } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-customer-doc-opp-currency-list',
  templateUrl: './epbt-fa-customer-doc-opp-currency-list.component.html',
  styleUrls: ['./epbt-fa-customer-doc-opp-currency-list.component.scss']
})
export class EpbtFaCustomerDocOppCurrencyListComponent implements OnInit {


  cardModel: any[];
  cardModels: any;
  currencyData: any[] = [];
  private _selectedCurrency: number;
  @Input('selectedCurrency') set selectedCurrency(value: number) {
    this._selectedCurrency = value;
    // this.selectedCurrencyChange.emit(this._selectedCurrency);
    // console.log(this._selectedCurrency);
    if (this._selectedCurrency) {
      var result = this.currencyData.filter(x => x.currencyId == this._selectedCurrency);
      this.selectedCurrencyChange.emit(result ? result[0] : null);
    }
  }
  get selectedCurrency(): number {
    return this._selectedCurrency;
  }
  @Input() isEditable: boolean = true;
  //@Input() readonly:boolean;
  // selectedTitle: string;
  @Output() selectedCurrencyChange = new EventEmitter<any>();

  constructor(private client: FieldAgentClient) { }


  ngOnInit() {
    //this.currencyData = ['AUD - Australian Dollar', 'CDN - CDN Dollar', 'EUR - Euro', 'GBP - Sterling', 'GBP2 - Sterling 2', 'SP - Scott', 'USD - US Dollar'];
    this.GetcurrencyData();
  }
  GetcurrencyData() {
    this.client.getCurrencyList().subscribe(res => {
      this.currencyData = res;
      this.selectedCurrency = 3;
      // var result = this.currencyData.filter(x => x.currencyId == this._selectedCurrency);
      // this.selectedCurrencyChange.emit(result ? result[0] : null);
      // res.forEach(data => {

      //   this.cardModel = [
      //     {
      //       userData: {
      //         displayname: this.getCurrencyData(data)
      //       }
      //     }
      //   ];
      //   this.cardModels.push(this.cardModel);

      // });
      // console.log(this.cardModels,"currency data started")
      // this.currencyData = this.cardModels;
      // console.log(this.currencyData,"currency data this");
    });
  }

  getCurrencyData(currencyObj: any) {
    let currency = '';
    (currencyObj.name) ? currency += '' + currencyObj.name : '';
    (currencyObj.symbol) ? currency += ', ' + currencyObj.symbol : '';
    return currency;
  }

  onSelectionChange(selectedValue: any) {
    if (selectedValue) {
      this.selectedCurrency = selectedValue.currencyId;
      var result = this.currencyData.filter(x => x.currencyId == this.selectedCurrency);
      this.selectedCurrencyChange.emit(result ? result[0] : null);
    }
  }

}
